function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MarkdownIt = require('markdown-it'); // markdown-it plugins


var emoji = require('markdown-it-emoji'); // const checkbox = require('markdown-it-task-checkbox');


var linkAttributes = require('markdown-it-link-attributes');

var implicitFigures = require('markdown-it-implicit-figures');

var mark = require('markdown-it-mark');

var ins = require('markdown-it-ins');

var abbr = require('markdown-it-abbr');

var deflist = require('markdown-it-deflist');

var video = require('markdown-it-video');

function createParser(_options, _extraPlugins) {
  // default options
  var options;

  if (typeof _options === 'undefined') {
    options = {};
  } else {
    options = _options;
  } // default extra plugins


  var extraPlugins;

  if (typeof _extraPlugins === 'undefined') {
    extraPlugins = [];
  } else {
    extraPlugins = _extraPlugins;
  } // type validations


  if (_typeof(options) !== 'object') {
    throw new TypeError('The markdown parser options must be an object.');
  }

  if (!Array.isArray(extraPlugins)) {
    throw new TypeError('The parser extra plugins must be an array.');
  } // Initialize the MD parser and apply plugins


  var parser = new MarkdownIt(Object.assign({
    html: false,
    breaks: true,
    linkify: true,
    xhtmlOut: true,
    typographer: true,
    langPrefix: 'language-'
  }, options));
  parser.use(emoji); // parser.use(checkbox);

  parser.use(linkAttributes, {
    target: '_blank',
    rel: 'nofollow'
  });
  parser.use(implicitFigures);
  parser.use(mark);
  parser.use(ins);
  parser.use(abbr);
  parser.use(deflist);
  parser.use(video, options.video || {}); // apply extra plugins

  extraPlugins.forEach(function (extraPlugin) {
    if (Array.isArray(extraPlugin)) {
      var _extraPlugin = _slicedToArray(extraPlugin, 2),
          plugin = _extraPlugin[0],
          config = _extraPlugin[1];

      return parser.use(plugin, config || {});
    }

    parser.use(extraPlugin);
  });
  return function parse(html) {
    return parser.render(html);
  };
}

module.exports = createParser;